import { useState as _useState$ } from "react";
import { renderReactScope as _renderReactScope$ } from "million/react";
import { For as _For$ } from "million/react";
import { block as _block$ } from "million/react";
import { useState, useEffect } from "react";
import LogoVitrum from '../Imagenes/Logos/LogoVitrum.png';
const M$2 = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const scrollToSection = sectionId => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth"
      });
    }
    setMenuOpen(false);
  };
  const navItems = [{
    id: "inicio",
    label: "Inicio"
  }, {
    id: "servicios",
    label: "Servicios"
  }, {
    id: "nosotros",
    label: "Nosotros"
  }, {
    id: "clientes",
    label: "Clientes"
  }, {
    id: "equipo",
    label: "Equipo"
  }, {
    id: "contacto",
    label: "Contacto"
  }];
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      if (!isMobile) {
        if (window.scrollY > lastScrollY && window.scrollY > 100) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
        setLastScrollY(window.scrollY);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile, lastScrollY]);
  const _portal = _useState$(() => ({
      $: new Array(4)
    }))[0],
    _ = `z-50 fixed w-full transition-all duration-300 
                ${isMobile ? "mt-4" : ""}
                ${!isMobile && !isVisible ? "-translate-y-full" : ""}
                ${!isMobile && isScrolled ? "bg-[#0e0f11]/90 backdrop-blur-lg " : "bg-transparent"}
            `,
    _2 = `flex items-center justify-between px-6 lg:px-8 ${isMobile ? "" : "py-4"}`,
    _3 = _renderReactScope$(<_For$ each={navItems}>{item => _temp({
        item: item,
        navItems: navItems,
        scrollToSection: scrollToSection
      })}</_For$>, false, _portal.$, 0, false),
    _4 = () => scrollToSection("contacto"),
    _5 = menuOpen ? "Cerrar menú" : "Abrir menú",
    _6 = _renderReactScope$(menuOpen ? <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg> : <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                            </svg>, false, _portal.$, 1, false),
    _7 = `lg:hidden fixed top-0 left-0 w-72 h-screen bg-[#0a0b0d] border-r border-white/5 transform transition-transform duration-300 ease-out z-40 ${menuOpen ? "translate-x-0" : "-translate-x-full"}`,
    _8 = _renderReactScope$(<_For$ each={navItems}>{item => _temp2({
        item: item,
        navItems: navItems,
        scrollToSection: scrollToSection
      })}</_For$>, false, _portal.$, 2, false),
    _9 = () => scrollToSection("contacto"),
    _10 = _renderReactScope$(menuOpen && isMobile && <div className="lg:hidden fixed inset-0 bg-black/60 backdrop-blur-sm z-30" onClick={toggleMenu} aria-hidden="true" />, false, _portal.$, 3, false);
  return <><P$ _={_} _2={_2} LogoVitrum={LogoVitrum} _3={_3} _4={_4} toggleMenu={toggleMenu} _5={_5} _6={_6} _7={_7} _8={_8} _9={_9} _10={_10} />{_portal.$.map(p => p.portal)}</>;
};
const P$ = /*million:transform*/_block$(({
  _,
  _2,
  LogoVitrum,
  _3,
  _4,
  toggleMenu,
  _5,
  _6,
  _7,
  _8,
  _9,
  _10
}) => {
  return <nav className={_}>
            <div className={_2}>
                <div className="flex items-center">
                    <img className="h-12 lg:h-14" src={LogoVitrum} alt="Vitrum Logo" />
                </div>

                {void 0}
                <div className="hidden lg:flex items-center gap-1 lg:gap-2">
                    {_3}
                    
                    {void 0}
                    <button onClick={_4} className="ml-4 px-5 py-2.5 text-sm font-semibold text-black bg-[#bdff57] rounded-lg hover:bg-[#a8e64c] transition-colors duration-300">
                        Hablemos
                    </button>
                </div>

                {void 0}
                <div className="lg:hidden relative z-50">
                    <button className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/5 text-white" onClick={toggleMenu} aria-label={_5}>
                        {_6}
                    </button>
                </div>
            </div>

            {void 0}
            <div className={_7}>
                <div className="p-6 pt-20">
                    <img src={LogoVitrum} alt="Vitrum" className="h-10 mb-10" />
                    
                    <div className="space-y-2">
                        {_8}
                    </div>
                    
                    <div className="mt-8 pt-8 border-t border-white/10">
                        <button onClick={_9} className="w-full py-3 text-sm font-semibold text-black bg-[#bdff57] rounded-lg hover:bg-[#a8e64c] transition-colors">
                            Hablemos
                        </button>
                    </div>
                </div>
            </div>

            {void 0}
            {_10}
        </nav>;
}, {
  svg: false,
  shouldUpdate: (a, b) => a?._ !== b?._ || a?._2 !== b?._2 || a?.LogoVitrum !== b?.LogoVitrum || a?._3 !== b?._3 || a?._4 !== b?._4 || a?.toggleMenu !== b?.toggleMenu || a?._5 !== b?._5 || a?._6 !== b?._6 || a?._7 !== b?._7 || a?._8 !== b?._8 || a?._9 !== b?._9 || a?._10 !== b?._10
});
const BarraSuperior = M$2;
export default BarraSuperior;
const callback$ = ({
  item,
  navItems,
  scrollToSection
}) => {
  const _11 = item.id,
    _12 = `#${item.id}`,
    _13 = e => {
      e.preventDefault();
      scrollToSection(item.id);
    },
    _14 = item.label;
  return <P$2 _11={_11} _12={_12} _13={_13} _14={_14} />;
};
const P$2 = /*million:transform*/_block$(({
  _11,
  _12,
  _13,
  _14
}) => {
  return <div key={_11} className="group">
                            <a href={_12} className="relative px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-colors duration-300 rounded-lg" onClick={_13}>
                                {_14}
                                <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-[#bdff57] transition-all duration-300 ease-out group-hover:w-4/5 rounded-full"></span>
                            </a>
                        </div>;
}, {
  svg: false,
  shouldUpdate: (a, b) => a?._11 !== b?._11 || a?._12 !== b?._12 || a?._13 !== b?._13 || a?._14 !== b?._14
});
callback$.__block_callable__ = true;
const _temp = callback$;
const callback$2 = ({
  item,
  navItems,
  scrollToSection
}) => {
  const _15 = item.id,
    _16 = `#${item.id}`,
    _17 = e => {
      e.preventDefault();
      scrollToSection(item.id);
    },
    _18 = item.label;
  return <P$3 _15={_15} _16={_16} _17={_17} _18={_18} />;
};
const P$3 = /*million:transform*/_block$(({
  _15,
  _16,
  _17,
  _18
}) => {
  return <a key={_15} href={_16} className="block px-4 py-3 text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors font-medium" onClick={_17}>
                                {_18}
                            </a>;
}, {
  svg: false,
  shouldUpdate: (a, b) => a?._15 !== b?._15 || a?._16 !== b?._16 || a?._17 !== b?._17 || a?._18 !== b?._18
});
callback$2.__block_callable__ = true;
const _temp2 = callback$2;